import { cn } from "tailwind-variants";
import type {
	DividerUmbBlockElementModel,
	DividerUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import { tryGetAnimationScrollType } from "#/_packages/umbrella/utils";

type DividerBlockProps = BlockItemProps & {
	content: DividerUmbBlockElementModel;
	settings: DividerUmbBlockSettingsElementModel;
};

export default function DividerUmbBlock({
	className,
	content,
	settings,
}: DividerBlockProps) {
	const properties = content.properties;
	const settingsProperties = settings.properties;
	const animationScrollType = tryGetAnimationScrollType(
		settingsProperties?.animationScrollType,
	);
	const verticalSize = properties?.verticalSize;

	return (
		<div
			id={settingsProperties?.generatedId ?? undefined}
			className={cn(
				"block__divider",
				properties?.intentColor && `divider-${properties.intentColor}`,
				animationScrollType !== "none" && animationScrollType,
				toAlignmentSelfVerticalClass(settingsProperties?.alignmentSelfVertical),
				className,
			)}
			style={
				verticalSize != null
					? {
							margin: `calc(${verticalSize} * var(--umb-divider-margin-multiplier)) 0`,
						}
					: undefined
			}
		></div>
	);
}

function toAlignmentSelfVerticalClass(value?: string | null) {
	switch (value) {
		case "start":
			return "self-start";
		case "center":
			return "self-center";
		case "end":
			return "self-end";
		default:
			return "";
	}
}
